import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledRichIconProps, IStyledRichListProps } from './RichList.types';

export const StyledIcon = styled.span<IStyledRichIconProps>`
  display: block;
  width: ${({ iconWidth }) => iconWidth && rem(iconWidth)};
  margin-bottom: ${({ theme }) => rem(theme.spacings.xs)};

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const StyledListItem = styled.li`
  list-style: none;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  font-weight: 400;
  line-height: 1.4;
`;

export const StyledList = styled.ul<IStyledRichListProps>`
  margin: 0;
  padding: 0;

  ${({ grid }) =>
    grid
      ? `
    display: flex;
    flex-wrap: wrap;
    padding: ${rem('30px')};

    ${StyledListItem} {
      flex-basis: 50%;
      padding: ${rem('12px')};
    }
  `
      : `
    ${StyledListItem} {
      &:not(:last-child) {
        margin-bottom: ${rem('40px')};
      }
    }
  `}
`;

export const StyledTitle = styled.h3`
  margin: 0 0 ${({ theme }) => rem(theme.spacings.xs)} 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('20px')};
  font-weight: 600;
`;
